import { render } from "./PopUpMenuFile.vue?vue&type=template&id=0509bc3e"
import script from "./PopUpMenuFile.vue?vue&type=script&lang=js"
export * from "./PopUpMenuFile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__